"use client";

import Login from "@/components/auth/Login";
import { useParams, useSearchParams } from "next/navigation";
import type { SupportedLanguage } from "@/lib/shared";
import { resolveLocale } from "@/lib/resolvedLocale";

export default function LoginPageRoute() {
  const params = useParams();
  const search = useSearchParams();
  const locale: SupportedLanguage = resolveLocale(params.locale as string | undefined);
  const tab = search.get("tab") || "email";
  const redirect = search.get("redirect") || undefined;

  return (
    <Login locale={locale} tab={tab} redirect={redirect} withImage={true} />
  );
}
